export const ACCESS_TOKEN_URL = 'https://api.kameleoon.com/oauth/token';
export const DEFAULT_CLEANUP_INTERVAL = 30;
